import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.string.fixed.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.search.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import Checkbox from "../../../wui-checkbox/src";
import Icon from "../../../wui-icon/src";
import Button from "../../../wui-button/src";
import Input from "../../../wui-input/src";
import { ObjectAssign } from "./util";
import i18n from "./i18n";
import { getComponentLocale } from "../../../wui-locale/src/tool";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PropTypes from "prop-types";

function noop() {}
/**
 * 参数: 过滤表头
 * @param {*} Table
 * @param {*} Popover
 * @param {*} Icon
 */


export default function filterColumn(Table, Popover) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(FilterColumn, _Component);

    var _super = _createSuper(FilterColumn);

    function FilterColumn(props) {
      var _this;

      _classCallCheck(this, FilterColumn);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "setColumOrderByIndex", function (_column) {
        _column.forEach(function (da) {
          //默认所有的列都显示，如果传递ifshow属性，根据ifshow属性值来判断是否显示某列
          if (da.hasOwnProperty("ifshow")) {
            da.checked = da.ifshow ? true : false;
            da.ifshow = da.checked;
          } else {
            da.checked = true;
            da.ifshow = true;
          }
        });

        return _column;
      });

      _defineProperty(_assertThisInitialized(_this), "checkedColumItemClick", function (da) {
        var _this$props = _this.props,
            checkMinSize = _this$props.checkMinSize,
            afterFilter = _this$props.afterFilter; // if(checkMinSize)

        var sum = 0,
            leng = 0;

        _this.state.tempColumns.forEach(function (da) {
          da.fixed ? "" : leng++;
          !da.fixed && da.checked ? sum++ : "";
        });

        if (sum < checkMinSize && da.checked) {
          return;
        } else {
          if (sum <= 1 && da.checked) return;
        }

        da.checked = da.checked ? false : true;
        da.ifshow = da.checked ? true : false;

        _this.setState(_objectSpread({}, _this.state)); //afterFilter(da, this.state.columns);

      });

      _defineProperty(_assertThisInitialized(_this), "openCloumList", function () {
        _this.setState({
          showModal: true
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onHide", function () {
        _this.setState({
          showModal: false
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
        console.log(e);

        _this.setState({
          searchStr: e || ''
        });
      });

      _defineProperty(_assertThisInitialized(_this), "search", function (str) {
        console.log(str);
        return str.title.indexOf(_this.state.searchStr) !== -1;
      });

      _defineProperty(_assertThisInitialized(_this), "getCloumItem", function () {
        var prefixCls = _this.props.prefixCls;
        var tempColumns = _this.state.tempColumns;
        _this.dragArr = [];
        _this.unDragArr = [];
        tempColumns.forEach(function (da, i) {
          var paramObj = {
            id: da.key,
            checked: da.checked
          };

          if (da.fixed || da.required) {
            paramObj.disabled = true;

            _this.unDragArr.push(da);
          } else {
            paramObj.onClick = function () {
              _this.checkedColumItemClick(da);
            };

            _this.dragArr.push(da);
          }
        });
        return /*#__PURE__*/React.createElement(DragDropContext, {
          onDragEnd: _this.onDragEnd
        }, _this.unDragArr.filter(_this.search).map(function (da, i) {
          return /*#__PURE__*/React.createElement("div", {
            key: da.key + "_" + i,
            className: "".concat(prefixCls, "-pop-cont-item")
          }, /*#__PURE__*/React.createElement(Checkbox, {
            id: da.key,
            checked: da.checked,
            disabled: true
          }, da.title));
        }), /*#__PURE__*/React.createElement(Droppable, {
          droppableId: "droppable"
        }, function (provided, snapshot) {
          return /*#__PURE__*/React.createElement("div", {
            ref: provided.innerRef
          }, _this.dragArr.filter(_this.search).map(function (da, i) {
            return /*#__PURE__*/React.createElement(Draggable, {
              key: da.key + "_" + i,
              index: i,
              draggableId: da.key + "_" + i
            }, function (provided, snapshot) {
              return /*#__PURE__*/React.createElement("div", _extends({
                ref: provided.innerRef
              }, provided.draggableProps, provided.dragHandleProps, {
                key: da.key + "_" + i,
                className: "".concat(prefixCls, "-pop-cont-item")
              }), /*#__PURE__*/React.createElement(Checkbox, {
                id: da.key,
                checked: da.checked,
                onClick: function onClick() {
                  return _this.checkedColumItemClick(da);
                }
              }, da.title));
            });
          }), provided.placeholder);
        }));
      });

      _defineProperty(_assertThisInitialized(_this), "clear", function () {
        var srcColumns = _this.state.srcColumns;
        srcColumns.forEach(function (da) {
          da.checked = true;
          da.ifshow = true;
        });

        _this.setState({
          tempColumns: srcColumns,
          searchStr: ''
        }); //this.props.afterFilter(this.state.tempColumns, this.state.columns);

      });

      _defineProperty(_assertThisInitialized(_this), "getCloumnsScroll", function (columns) {
        var sum = 0;
        columns.forEach(function (da) {
          if (da.checked) {
            sum += da.width;
          }
        }); // console.log("sum",sum);

        return sum;
      });

      _defineProperty(_assertThisInitialized(_this), "save", function () {
        _this.setState({
          columns: ObjectAssign(_this.state.tempColumns)
        });

        _this.props.afterFilter(_this.state.columns, _this.state.tempColumns);

        _this.onHide();
      });

      _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (result) {
        console.log(result);

        if (!result.destination) {
          return;
        }

        var tempColumns = _this.state.tempColumns;

        var _this$dragArr$splice = _this.dragArr.splice(result.source.index, 1),
            _this$dragArr$splice2 = _slicedToArray(_this$dragArr$splice, 1),
            removed = _this$dragArr$splice2[0];

        _this.dragArr.splice(result.destination.index, 0, removed);

        _this.setState({
          tempColumns: _this.unDragArr.concat(_this.dragArr)
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getItemStyle", function (isDragging, draggableStyle) {
        return {//userSelect: "none",
          //background: isDragging ? "lightgreen" : "grey",
          //...draggableStyle
        };
      });

      _defineProperty(_assertThisInitialized(_this), "getListStyle", function (isDraggingOver) {
        return {//background: isDraggingOver ? "lightblue" : "lightgrey",
          //position: "relative"
        };
      });

      _defineProperty(_assertThisInitialized(_this), "onVisible", function (bool) {
        console.log(bool);

        if (bool) {
          // 弹框显示，同步popover要展示的数据
          _this.setState({
            tempColumns: ObjectAssign(_this.state.columns),
            searchStr: ''
          });
        }
      });

      var _columns2 = props.columns;
      _this.state = {
        columns: _this.setColumOrderByIndex(ObjectAssign(_columns2)),
        tempColumns: _this.setColumOrderByIndex(ObjectAssign(_columns2)),
        //修改，未确定之前，临时的变量,popover展示的数据源
        srcColumns: _this.setColumOrderByIndex(ObjectAssign(_columns2)),
        //最原始的数据源
        showModal: false,
        searchStr: '',
        screenY: 0
      };
      return _this;
    }

    _createClass(FilterColumn, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.columns != this.props.columns) {
          this.setState({
            columns: this.setColumOrderByIndex(ObjectAssign(nextProps.columns)),
            tempColumns: this.setColumOrderByIndex(ObjectAssign(nextProps.columns)),
            srcColumns: this.setColumOrderByIndex(ObjectAssign(nextProps.columns))
          });
        }

        this.setState({
          showModal: nextProps.showFilterPopover ? true : false
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            data = _this$props2.data,
            prefixCls = _this$props2.prefixCls,
            scrollPro = _this$props2.scroll;
        var _this$state = this.state,
            columns = _this$state.columns,
            showModal = _this$state.showModal;
        var locale = getComponentLocale(this.props, this.context, 'Table', function () {
          return i18n;
        });
        var _columns = [],
            widthState = 0,
            scroll = scrollPro;
        columns.forEach(function (da) {
          if (da.ifshow) {
            _columns.push(da);

            if (da.width) {
              widthState++;
            }
          }
        }); // if(_columns.length == widthState){
        //   scroll.x = this.getCloumnsScroll(columns);
        // }

        var content = /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-pop-cont")
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
          type: "search",
          value: this.state.searchStr,
          onChange: this.onChange,
          onSearch: this.onChange
        })), /*#__PURE__*/React.createElement("div", null, this.getCloumItem()), /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-pop-footer")
        }, /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-clear-setting"),
          onClick: this.clear
        }, locale["resetSettings"]), /*#__PURE__*/React.createElement(Button, {
          colors: "secondary",
          size: "sm",
          onClick: this.onHide
        }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
          colors: "primary",
          size: "sm",
          onClick: this.save
        }, "\u786E\u5B9A")));
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-cont")
        }, /*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
          columns: _columns,
          data: data // scroll={scroll}
          //  scroll={{x:this.getCloumnsScroll(columns)}}

        })), this.props.columnFilterAble == false ? "" : /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-filter-icon")
        }, /*#__PURE__*/React.createElement(Popover, {
          id: "filter_column_popover",
          placement: "left",
          content: content,
          show: showModal,
          onHide: this.onHide,
          onVisibleChange: this.onVisible,
          trigger: "click"
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-pop-column-filter-cont")
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "uf-3dot-h",
          onClick: this.openCloumList
        })))));
      }
    }]);

    return FilterColumn;
  }(Component), _defineProperty(_class, "defaultProps", {
    prefixCls: "u-table-filter-column",
    afterFilter: noop,
    columnFilterAble: true,
    scroll: {}
  }), _defineProperty(_class, "contextTypes", {
    beeLocale: PropTypes.object
  }), _temp;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/lib/filterColumn.js